// Kids Curriculum playlist videos — used by the "Video Lessons" and "First Sunday Songs"
// popouts under Resources → For Parents → Kids Curriculum.
//
//   Seedbed Lessons: https://www.youtube.com/playlist?list=PL8126j_-PzM-NutWFhJiz5F6IgOqo9Fd0
//   First Sunday Songs: https://www.youtube.com/playlist?list=PL8126j_-PzM9OK1bCAZlo8PSO4SGfyVvJ

export const FIRST_SUNDAY_SONGS = [
  { id: 'JsoOhl7RayE', title: '"Praise" (Elevation Worship) — Dance Motions', duration: '4:58' },
  { id: 'aTAtZcNJgbk', title: 'Glorious Day — Hand Motions', duration: '4:19' },
  { id: 'NlLaUGSOxHI', title: 'Sing Wherever I Go — We the Kingdom (Motions)', duration: '3:20' },
  { id: '0vFXs5Oi7Po', title: 'God So Loved — CH Kids Elementary Practice', duration: '4:04' },
  { id: '-_dx2RC4CuM', title: 'House of the Lord — LifePoint Kids Worship (Motions)', duration: '4:16' },
  { id: '1zb2Ne8okd4', title: 'Battle Belongs — Phil Wickham (Epic Kids Motions)', duration: '4:46' },
  { id: 'OaW_4MWSE6I', title: 'My Lighthouse — Grace Vineyard Kids (Actions)', duration: '3:47' },
  { id: 'deYTiN4iZBw', title: '"I Thank God" — Maverick City / UPPERROOM (Dance Motions)', duration: '5:23' },
  { id: '1DBWa5C9rdE', title: 'King of Kings — Hillsong (Epic Kids Motions)', duration: '4:26' },
];

// Seedbed animated video lessons (80 total: 40 OT + 40 NT).
// Titles preserved from the playlist so parents can locate the current Sunday's lesson.
export const SEEDBED_LESSONS = [
  { id: 'KltY9mMrSWU', title: 'Animated Video Lesson 1', duration: '3:41' },
  { id: 'WHEACXZIEJ4', title: 'Animated Video Lesson 2', duration: '5:48' },
  { id: 'aTihnCObyTY', title: 'Animated Video Lesson 3', duration: '6:12' },
  { id: '952TQNMY5Gg', title: 'Animated Video Lesson 4', duration: '3:15' },
  { id: '7VvGt2_u4b4', title: 'Animated Video Lesson 5', duration: '3:03' },
  { id: 'R115sgfAGiw', title: 'Animated Video Lesson 6', duration: '4:02' },
  { id: 'ls6uHD1PTMU', title: 'Animated Video Lesson 7', duration: '5:47' },
  { id: 'YXY832MBeqY', title: 'Animated Video Lesson 8', duration: '3:41' },
  { id: 'es-4kDxEtas', title: 'Animated Video Lesson 9', duration: '4:00' },
  { id: 'uzD_0yznnOE', title: 'Animated Video Lesson 10', duration: '3:22' },
  { id: 'NL0cphtQQlA', title: 'Animated Video Lesson 11', duration: '5:47' },
  { id: 'Wf7b4jR2ZPQ', title: 'Animated Video Lesson 12', duration: '4:12' },
  { id: 'gmD74mUAP-0', title: 'Animated Video Lesson 13', duration: '4:19' },
  { id: 'aDUoGF-RWi4', title: 'Animated Video Lesson 14', duration: '3:16' },
  { id: 'N25_kJBPdig', title: 'Animated Video Lesson 15', duration: '4:48' },
  { id: 'U3bURc1XleY', title: 'Animated Video Lesson 16', duration: '3:57' },
  { id: 'bNab0lw3GnM', title: 'Animated Video Lesson 17', duration: '4:13' },
  { id: 'UnuJHxqII0g', title: 'Animated Video Lesson 18', duration: '4:27' },
  { id: 'EAJQlCq7ujs', title: 'Animated Video Lesson 19', duration: '4:04' },
  { id: 'DF43R2SSgQg', title: 'Animated Video Lesson 20', duration: '4:01' },
  { id: 'IO4Q-JGyHWc', title: 'Animated Video Lesson 21', duration: '4:54' },
  { id: 'VDmuJVBDm8Y', title: 'Animated Video Lesson 22', duration: '3:39' },
  { id: 'QoESIuYS1co', title: 'Animated Video Lesson 23', duration: '3:12' },
  { id: 'Rem9s4p1_kU', title: 'Lesson 24 — David (Part 1)', duration: '4:53' },
  { id: 'l0YjBFJKwgA', title: 'Lesson 25 — David (Part 2)', duration: '3:02' },
  { id: 'J15cIkH8TIA', title: 'Lesson 26 — Abigail', duration: '4:14' },
  { id: '7zJSRink_as', title: 'Lesson 27 — Samuel', duration: '4:15' },
  { id: 'NOno9V9gC7U', title: 'Lesson 28 — Review', duration: '2:47' },
  { id: 'R6FLll2btHU', title: 'Lesson 29 — Elijah (Part 1)', duration: '3:54' },
  { id: 'zNnja7A8T6I', title: 'Lesson 30 — Elijah (Part 2)', duration: '4:17' },
  { id: 'wfBuOQI_D3k', title: 'Lesson 31 — Job', duration: '3:54' },
  { id: 'ZYtZ2m6s_Ks', title: 'Lesson 32 — Elisha', duration: '3:31' },
  { id: 'SJde_YMlTRk', title: 'Lesson 33 — Josiah', duration: '3:14' },
  { id: 'S0hKE2zbR7o', title: 'Lesson 34 — Nehemiah', duration: '3:00' },
  { id: 'kdpO8lsC5Jk', title: 'Lesson 35 — Esther', duration: '3:50' },
  { id: 'LBYyMvmFzmQ', title: 'Lesson 36 — Isaiah', duration: '3:29' },
  { id: 'hU4qrP3pGjE', title: 'Lesson 37 — Jeremiah', duration: '4:16' },
  { id: 'wyWXNwPjChQ', title: 'Lesson 38 — Daniel', duration: '2:59' },
  { id: '9jnpY3ac1No', title: 'Lesson 39 — Jonah', duration: '3:40' },
  { id: 'wjyRPwsxsFA', title: 'Lesson 40 — Malachi', duration: '4:49' },
  { id: 'l53ctlREaUg', title: 'NT Lesson 1', duration: '3:00' },
  { id: 'L-88Gv0qok4', title: 'NT Lesson 2', duration: '3:48' },
  { id: 'hwTQkxY1PIc', title: 'NT Lesson 3', duration: '3:00' },
  { id: 'sRLSXuv07HQ', title: 'NT Lesson 4', duration: '3:40' },
  { id: 'UuAdTuYYIdY', title: 'NT Lesson 5', duration: '3:12' },
  { id: '1kSO2esj5Iw', title: 'NT Lesson 6', duration: '3:23' },
  { id: 'V1CW7_E56Jg', title: 'NT Lesson 7', duration: '3:14' },
  { id: 'ikOf7iplQTc', title: 'NT Lesson 8', duration: '4:22' },
  { id: '5n6IyTxEZB8', title: 'NT Lesson 9', duration: '3:13' },
  { id: '0vKcD1qFS9g', title: 'NT Lesson 10', duration: '3:11' },
  { id: 'KsUbS3PYRCg', title: 'NT Lesson 11', duration: '3:18' },
  { id: 'RxyJ6k_KWEA', title: 'NT Lesson 12', duration: '3:18' },
  { id: 'kabGtfTThlg', title: 'NT Lesson 13', duration: '4:05' },
  { id: 'JYDS5rC5RnQ', title: 'NT Lesson 14', duration: '4:25' },
  { id: '-W51nPCOufQ', title: 'NT Lesson 15', duration: '4:07' },
  { id: 'wsRJnMJ5pmg', title: 'NT Lesson 16', duration: '4:04' },
  { id: 'MpNLHlcnXH4', title: 'NT Lesson 17', duration: '3:52' },
  { id: 'iJR7XRB5rk4', title: 'NT Lesson 18', duration: '2:12' },
  { id: 'Q6RrAR39ZmU', title: 'NT Lesson 19', duration: '3:03' },
  { id: 'LH9OmBXLCkU', title: 'NT Lesson 20', duration: '3:58' },
  { id: 'njz2HuNj76Y', title: 'NT Lesson 21', duration: '3:24' },
  { id: 'Ss8ru3BTE8o', title: 'NT Lesson 22', duration: '4:07' },
  { id: 'XtyGqk6X518', title: 'NT Lesson 23', duration: '3:45' },
  { id: 'heNl3XwbEUQ', title: 'NT Lesson 24', duration: '3:53' },
  { id: '20KnT6PuUWU', title: 'NT Lesson 25', duration: '3:51' },
  { id: 'vckisJAJTOA', title: 'NT Lesson 26', duration: '3:22' },
  { id: 'UOM55YdLBl0', title: 'NT Lesson 27', duration: '4:08' },
  { id: 'DBtIfazqOHQ', title: 'NT Lesson 28', duration: '3:18' },
  { id: 'MnP0XOi4DDs', title: 'NT Lesson 29', duration: '3:19' },
  { id: '_J-KeaySjHs', title: 'NT Lesson 30', duration: '4:47' },
  { id: 'HWVJhV0oFLI', title: 'NT Lesson 31', duration: '4:34' },
  { id: 'hJJh2kt2rzM', title: 'NT Lesson 32', duration: '3:07' },
  { id: 'HNcbl-lG2XQ', title: 'NT Lesson 33', duration: '3:00' },
  { id: 'rlJi4we-MmM', title: 'NT Lesson 34', duration: '3:55' },
  { id: 'JV2YBML2cAk', title: 'NT Lesson 35', duration: '4:44' },
  { id: 'hpwW0fYYmBg', title: 'NT Lesson 36', duration: '4:03' },
  { id: 'tEXtAAkjNE4', title: 'NT Lesson 37', duration: '4:12' },
  { id: 'MU_ys-g-yeg', title: 'NT Lesson 38', duration: '4:29' },
  { id: 'OwgJ8gjoB6s', title: 'NT Lesson 39', duration: '3:33' },
  { id: '3j8S7ItCyrc', title: 'NT Lesson 40', duration: '4:37' },
];
